var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgMenjavaVenDupla = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 100 100" }, props, { children: [_jsx("circle", { cx: 43, cy: 39, r: 17, fill: "#676767" }), _jsx("path", { fill: "currentColor", d: "M43.645 40.889h9.43V37.11h-9.43v-5.667L32.925 39l10.72 7.555z" }), _jsx("circle", { cx: 57, cy: 61, r: 17, fill: "#fff" }), _jsx("path", { fill: "currentColor", d: "M56.355 59.111h-9.429v3.778h9.43v5.667L67.073 61l-10.719-7.555z" })] }))); };
export default SvgMenjavaVenDupla;
